import React from 'react';

import css from './SiteDrawer.module.css';

const ICONS = {
  LandingPage: (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path
        d="M4.8 10.8 12 4.6l7.2 6.2V19a1.4 1.4 0 0 1-1.4 1.4h-3.6v-5.2h-4.4V20.4H6.2A1.4 1.4 0 0 1 4.8 19z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinejoin="round"
      />
    </svg>
  ),
  SearchPage: (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <circle cx="12" cy="8.2" r="2.6" fill="none" stroke="currentColor" strokeWidth="1.7" />
      <path
        d="M6.6 18.6c.6-3.1 2.6-4.7 5.4-4.7s4.8 1.6 5.4 4.7"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
      />
    </svg>
  ),
  NewListingPage: (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <circle cx="12" cy="8.2" r="2.6" fill="none" stroke="currentColor" strokeWidth="1.7" />
      <path
        d="M6.6 18.6c.6-3.1 2.6-4.7 5.4-4.7s4.8 1.6 5.4 4.7"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
      />
    </svg>
  ),
  HowItWorksPage: (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <circle cx="12" cy="12" r="7.2" fill="none" stroke="currentColor" strokeWidth="1.7" />
      <path
        d="M12 10.6v5.2M12 8.2v.2"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  ),
  AboutPage: (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <circle cx="12" cy="12" r="7.2" fill="none" stroke="currentColor" strokeWidth="1.7" />
      <path
        d="M12 10.6v5.2M12 8.2v.2"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  ),
  FAQPage: (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <circle cx="12" cy="12" r="7.2" fill="none" stroke="currentColor" strokeWidth="1.7" />
      <path
        d="M10.2 9.4c.3-1.2 1.3-1.9 2.6-1.9 1.4 0 2.4.8 2.4 2.1 0 1.4-1.2 1.9-1.9 2.3-.5.3-1 .7-1 1.5M12 16.6v.2"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
      />
    </svg>
  ),
  SafetyPage: (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path
        d="M12 3.6 19 6.4v5.8c0 4.1-2.9 7.1-7 8.4-4.1-1.3-7-4.3-7-8.4V6.4L12 3.6z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinejoin="round"
      />
    </svg>
  ),
  PricingPage: (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <circle cx="12" cy="12" r="7.2" fill="none" stroke="currentColor" strokeWidth="1.7" />
      <path
        d="M12 16.6v.3M9.6 9.4c.5-1.3 1.7-2 3.2-2 1.7 0 2.9 1 2.9 2.4 0 1.6-1.3 2.2-2.3 2.7-.7.3-1.4.8-1.4 1.7"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
      />
    </svg>
  ),
  ContactPage: (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <rect
        x="4.2"
        y="6.4"
        width="15.6"
        height="11.2"
        rx="1.6"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
      />
      <path
        d="m5 7.6 7 5.4 7-5.4"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinejoin="round"
      />
    </svg>
  ),
  DashboardPage: (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <rect
        x="4.4"
        y="4.4"
        width="6.4"
        height="6.4"
        rx="1.2"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
      />
      <rect
        x="13.2"
        y="4.4"
        width="6.4"
        height="6.4"
        rx="1.2"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
      />
      <rect
        x="4.4"
        y="13.2"
        width="6.4"
        height="6.4"
        rx="1.2"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
      />
      <rect
        x="13.2"
        y="13.2"
        width="6.4"
        height="6.4"
        rx="1.2"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
      />
    </svg>
  ),
  YourProfilePage: (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <circle cx="12" cy="8.2" r="2.6" fill="none" stroke="currentColor" strokeWidth="1.7" />
      <path
        d="M6.6 18.6c.6-3.1 2.6-4.7 5.4-4.7s4.8 1.6 5.4 4.7"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
      />
    </svg>
  ),
  AvailabilityPage: (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <circle cx="12" cy="12" r="7.2" fill="none" stroke="currentColor" strokeWidth="1.7" />
      <path
        d="M12 8.2v4.2l2.6 1.6"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  SessionsCalendarPage: (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <rect
        x="4.2"
        y="5.6"
        width="15.6"
        height="14"
        rx="1.6"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
      />
      <path
        d="M8 4.6v2.4M16 4.6v2.4M4.2 10h15.6"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
      />
    </svg>
  ),
  InboxPage: (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path
        d="M5 7.2h14v10.2a1.4 1.4 0 0 1-1.4 1.4H6.4A1.4 1.4 0 0 1 5 17.4z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
      />
      <path
        d="m5.4 7.6 6.6 5.2 6.6-5.2"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Favorites: (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path
        d="M12 19.2 6.4 14c-2.2-2.1-2.2-5.5.1-7.5 1.8-1.5 4.5-1.1 5.5.8 1-1.9 3.7-2.3 5.5-.8 2.3 2 2.3 5.4.1 7.5z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinejoin="round"
      />
    </svg>
  ),
  PromotePage: (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path
        d="M5.5 10.2 18 5.6l-3.2 12.6-3.4-3.3-2.6 2.5v-3.8z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinejoin="round"
      />
    </svg>
  ),
  TipsPage: (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path
        d="M7 5.4h9.2A1.8 1.8 0 0 1 18 7.2v11.2H8.4A1.8 1.8 0 0 1 6.6 16.6V7.2A1.8 1.8 0 0 1 8.4 5.4"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
      />
      <path
        d="M9.2 9.2h6.2M9.2 12.2h6.2M9.2 15.2h3.8"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
      />
    </svg>
  ),
  GuidesPage: (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path
        d="M7 5.4h9.2A1.8 1.8 0 0 1 18 7.2v11.2H8.4A1.8 1.8 0 0 1 6.6 16.6V7.2A1.8 1.8 0 0 1 8.4 5.4"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
      />
      <path
        d="M9.2 9.2h6.2M9.2 12.2h6.2M9.2 15.2h3.8"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
      />
    </svg>
  ),
  HelpPage: (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <circle cx="12" cy="12" r="7.2" fill="none" stroke="currentColor" strokeWidth="1.7" />
      <path
        d="M10.2 9.4c.3-1.2 1.3-1.9 2.6-1.9 1.4 0 2.4.8 2.4 2.1 0 1.4-1.2 1.9-1.9 2.3-.5.3-1 .7-1 1.5M12 16.6v.2"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
      />
    </svg>
  ),
};

/**
 * Line icon for a mock drawer destination.
 *
 * @param {Object} props
 * @param {string} props.routeName
 * @returns {JSX.Element|null}
 */
const SiteDrawerIcon = props => {
  const glyph = ICONS[props.routeName];
  if (!glyph) {
    return null;
  }
  return <span className={css.icon}>{glyph}</span>;
};

export default SiteDrawerIcon;
